import React from 'react';
import { useIntl } from 'react-intl';
import { getWarehouseApiUrl } from '../../../helpers/url';
import { Capabilities } from '../../../types/warehouse/user';
import Resources from './Resources';

interface StorageResourcesProps {
    id: number;
}

const getUrl = (id: number) => getWarehouseApiUrl('storages/:id/resources', { params: { id } });
const getResourceUrl = (id: number) => (resourceId: number) =>
    getWarehouseApiUrl('storages/:id/resources/:resourceId', { params: { id, resourceId } });

export default ({ id }: StorageResourcesProps) => {
    const { formatMessage } = useIntl();
    const title = formatMessage({ id: 'resources.storages.title', defaultMessage: 'Storage resources' });

    return <Resources url={getUrl(id)} getResourceUrl={getResourceUrl(id)} title={title}
        capability={Capabilities.PRODUCTS_MANAGE} />;
}
